import GenericSlide from "./GenericSlide";

export type CatalogCard = {
  product_id?: number;
  body?: string;
  image_url?: string;
  token_id?: string;
};

type Props = {
  card: CatalogCard;
  buttonTitle?: string;
};

/**
 * One AI-agent catalog card, rendered read-only for the operator.
 *
 * The card body arrives as the provider renders it — "*Name*" on the first
 * line, price on the next — so the name becomes the title and the rest the
 * subtitle. The button is display-only here: tapping it is the customer's
 * action, and its token only resolves in their chat.
 */
const CatalogSlide = ({ card, buttonTitle }: Props) => {
  const [firstLine, ...rest] = (card.body ?? "").split("\n");

  return (
    <GenericSlide
      title={firstLine.replace(/\*/g, "").trim()}
      subtitle={rest.join("\n").trim()}
      image_url={card.image_url}
      buttons={
        buttonTitle
          ? [{ type: "postback", title: buttonTitle, payload: "" }]
          : undefined
      }
    />
  );
};

export default CatalogSlide;
